<template>
    <IconSvg viewBox="0 0 48 48" v-bind="$attrs" v-slot="{ filled }">
        <g v-if="filled"><path fill-rule="evenodd" clip-rule="evenodd" d="M12 4C10.8954 4 10 4.89543 10 6V42C10 43.1046 10.8954 44 12 44H36C37.1046 44 38 43.1046 38 42V6C38 4.89543 37.1046 4 36 4H12ZM24 42C25.1046 42 26 41.1046 26 40C26 38.8954 25.1046 38 24 38C22.8954 38 22 38.8954 22 40C22 41.1046 22.8954 42 24 42ZM35 7H13V36H35V7Z" fill-opacity="0.9"></path></g>
<g v-else><path fill-rule="evenodd" clip-rule="evenodd" d="M12.4 41.6V6.4H35.6V41.6H12.4ZM10 6C10 4.89543 10.8954 4 12 4H36C37.1046 4 38 4.89543 38 6V42C38 43.1046 37.1046 44 36 44H12C10.8954 44 10 43.1046 10 42V6ZM26 38C26 39.1046 25.1046 40 24 40C22.8954 40 22 39.1046 22 38C22 36.8954 22.8954 36 24 36C25.1046 36 26 36.8954 26 38Z"></path></g>
    </IconSvg>
</template>

<script>
import IconSvg from '../../svg.vue';
export default {
    components: {
        IconSvg,
    },
};
</script>
